/*
 * Cosmora: don't let the "Manage preferences" X silently drop the cookie question.
 *
 * Shopify's banner script (storefront-banner.js) shows the banner (#shopify-pc__banner) and the
 * preferences modal (#shopify-pc__prefs) with an inline display style. Closing the modal with
 * its X (#shopify-pc__prefs__header-close) hides the modal and the banner together without
 * recording any consent, so the visitor loses the Accept / Decline buttons for the rest of
 * that page. When that happens this script shows Shopify's banner again.
 *
 * This is not a forced choice: the page stays scrollable and interactive, nothing is dimmed,
 * and the banner keeps Shopify's default layout, where Accept and Decline look identical.
 * The re-show happens only after the preferences modal closes with no decision recorded, and
 * at most MAX_RESHOWS times per page.
 */
(function () {
  if (window.cosmoraConsentPrefsClose) return;
  window.cosmoraConsentPrefsClose = true;

  var BANNER_ID = 'shopify-pc__banner';
  var PREFS_ID = 'shopify-pc__prefs';
  var MAX_RESHOWS = 3;

  var prefsWasOpen = false;
  var reshows = 0;
  var updateQueued = false;
  var styleObserver = new MutationObserver(scheduleUpdate);

  function isShown(element) {
    return !!element && element.isConnected && window.getComputedStyle(element).display !== 'none';
  }

  function watch(element) {
    if (!element || element.cosmoraPrefsCloseWatched) return;
    element.cosmoraPrefsCloseWatched = true;
    styleObserver.observe(element, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
  }

  function noDecisionYet() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.currentVisitorConsent !== 'function') return false;
    var consent = privacy.currentVisitorConsent();
    return consent.analytics === '' && consent.marketing === '' && consent.preferences === '';
  }

  function update() {
    updateQueued = false;
    var banner = document.getElementById(BANNER_ID);
    var prefs = document.getElementById(PREFS_ID);
    watch(banner);
    watch(prefs);

    var prefsOpen = isShown(prefs);
    var bannerOpen = isShown(banner);

    if (prefsWasOpen && !prefsOpen && !bannerOpen && noDecisionYet() && reshows < MAX_RESHOWS) {
      var banners = window.privacyBanner;
      if (banners && typeof banners.showBanner === 'function') {
        reshows += 1;
        banners.showBanner();
      }
    }

    prefsWasOpen = prefsOpen;
  }

  function scheduleUpdate() {
    if (updateQueued) return;
    updateQueued = true;
    Promise.resolve().then(update);
  }

  function start() {
    new MutationObserver(scheduleUpdate).observe(document.body, { childList: true });
    document.addEventListener('visitorConsentCollected', scheduleUpdate);
    update();
  }

  if (document.body) {
    start();
  } else {
    document.addEventListener('DOMContentLoaded', start);
  }
})();
